/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import { TextField, Typography } from "@mui/material";
import OTPVerificationController from "Controller/OTPVerificationController";

function OTPVerification() {
  const {
    vendorCode,
    mobile,
    OTP,
    errors,
    handleOTPChange,
    handleSubmit,
    handleOTPverify,
    resendOTP,
    canResend,
    resendTimer,
    formatTimer,
  } = OTPVerificationController();

  return (
    <BasicLayout image={null}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="error"
          borderRadius="lg"
          coloredShadow="error"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            OTP Verification
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox role="form">
            <MDBox mb={2}>
              <Typography variant="h6" textAlign={"center"} fullWidth>
                Your OTP: {OTP}
              </Typography>
            </MDBox>

            <MDBox mb={2}>
              <MDInput
                type="text"
                label="OTP"
                name="otp"
                fullWidth
                onChange={(e) => handleOTPChange(e)}
              />
              <Typography variant="span" style={{ color: "red", fontSize: "0.9rem" }} fullWidth>
                {errors.otp || ""}
              </Typography>
            </MDBox>

            <MDBox mt={4} mb={1}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "flex-end", sm: "flex-start" },
                    marginBottom: { xs: "10px", sm: "none" },
                  }}
                >
                  <Typography
                    variant="h6"
                    fullWidth
                    textAlign={"right"}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      cursor: canResend ? "pointer" : "not-allowed",
                      color: canResend ? "#344767" : "gray",
                    }}
                    onClick={canResend ? resendOTP : undefined}
                    onKeyDown={(e) => {
                      if (canResend && (e.key === "Enter" || e.key === " ")) {
                        resendOTP();
                      }
                    }}
                  >
                    {canResend ? "Resend OTP" : `Resend OTP (${formatTimer(resendTimer)})`}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MDBox display="flex" justifyContent="flex-end">
                    <Typography
                      variant="h6"
                      component={Link}
                      to="/login"
                      style={{
                        textDecoration: "none",
                        display: "inline-block", // only text clickable
                      }}
                    >
                      Back To Login
                    </Typography>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton
                type="submit"
                variant="gradient"
                color="error"
                fullWidth
                onClick={() => handleOTPverify()}
              >
                Verify
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default OTPVerification;
